import { render, staticRenderFns } from "./proof-change-timeline.vue?vue&type=template&id=4a76b1b5&scoped=true&"
import script from "./proof-change-timeline.vue?vue&type=script&lang=js&"
export * from "./proof-change-timeline.vue?vue&type=script&lang=js&"
import style0 from "./proof-change-timeline.vue?vue&type=style&index=0&id=4a76b1b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a76b1b5",
  null
  
)

export default component.exports